import styled from '@emotion/styled'
import { TFunction } from 'i18next'
import React, { useState } from 'react'

import { useTypedSelector } from '../../'
import ArrowDown from '../../icons/ArrowDown'
import ArrowUp from '../../icons/ArrowUp'
import Exclamation from '../../icons/Exclamation'
import { defaultTextColor, getColor, theme } from '../../Theme'
import ErrorText from '../ErrorText'

const BackupContainer = styled.div`
  ${theme.layout.flexColumn};
  align-items: flex-start;
  ${theme.effects.shadow};
  background: ${(p) => getColor(p.theme, ['white'], ['nightBlack'])};
`

const DescriptionRow = styled.div`
  ${theme.layout.flexRow};
  ${theme.spacing.sides('small')};
  color: ${defaultTextColor};
`

const BackupDescription = styled.div`
  ${theme.text('normal', 'content', 'bold')};
  ${theme.spacing.sides('small')};
  text-align: center;
`

const BackupLink = styled.a`
  ${theme.text('small')};
  ${theme.spacing.sides('large')}
`

const LinkList = styled.div`
  ${theme.layout.flexRow};
  justify-content: space-evenly;
  width: 100%;
`
const MediumErrorText = styled(ErrorText)`
  ${theme.text('normal', 'decorative', 'bold')};
  margin: ${theme.spacing.sizes.large};
  color: red;
`

type Props = {
  t: TFunction
}

const BackupTimetable = ({ t }: Props) => {
  const [showLinks, setShowLinks] = useState(false)
  const { backupTimetableLink1, backupTimetableLink2 } = useTypedSelector(
    (state) => state.configurations.data
  )

  return (
    <BackupContainer>
      <DescriptionRow onClick={() => setShowLinks(!showLinks)}>
        <Exclamation iconSize="extraHuge" />
        <BackupDescription>{t('backupTimetableDescription')}</BackupDescription>
        {showLinks ? <ArrowUp iconSize="large" /> : <ArrowDown iconSize="large" />}
      </DescriptionRow>
      {showLinks && (
        <LinkList>
          {backupTimetableLink1 ? (
            <BackupLink target={'_blank'} href={backupTimetableLink1}>
              {t('link1')}
            </BackupLink>
          ) : (
            <MediumErrorText>{t('errors.general.noLink')}</MediumErrorText>
          )}
          {backupTimetableLink2 ? (
            <BackupLink target={'_blank'} href={backupTimetableLink2}>
              {t('link2')}
            </BackupLink>
          ) : (
            <MediumErrorText>{t('errors.general.noLink')}</MediumErrorText>
          )}
        </LinkList>
      )}
    </BackupContainer>
  )
}

export default BackupTimetable
